"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_CURRENCY_CODE = void 0;
Object.defineProperty(exports, "currenciesMessages", {
  enumerable: true,
  get: function () {
    return _messages.currenciesMessages;
  }
});
exports.getSupportedCurrencies = exports.getCurrencyByValue = exports.getCurrencyByKey = exports.default = void 0;
var _defaultCurrencyStore = _interopRequireDefault(require("./default-currency-store.json"));
var _messages = require("./messages");
var _supportedCurrencies = _interopRequireDefault(require("./supported-currencies.json"));
const DEFAULT_CURRENCY_CODE = exports.DEFAULT_CURRENCY_CODE = 'USD';
const emptyCurrency = {
  key: null,
  value: null,
  label: null
};
const getStoreCurrencyCode = storeId => {
  const store = _defaultCurrencyStore.default[storeId];
  return store ? store.currencyCode : null;
};

// Return a promise because in the future we may change the json file for an asyncronous API call
const getCurrencyByKey = (key = 'USD') => {
  const currency = _supportedCurrencies.default.find(({
    key: currencyKey
  }) => currencyKey === key);
  const result = currency ? currency : emptyCurrency;
  return new Promise(resolve => resolve(result));
};
exports.getCurrencyByKey = getCurrencyByKey;
const getCurrencyByValue = (value = 'USD') => {
  const currency = _supportedCurrencies.default.find(({
    value: currencyValue
  }) => currencyValue === value);
  const result = currency ? currency : emptyCurrency;
  return new Promise(resolve => resolve(result));
};
exports.getCurrencyByValue = getCurrencyByValue;
const getSupportedCurrencies = () => new Promise(resolve => resolve(_supportedCurrencies.default));
exports.getSupportedCurrencies = getSupportedCurrencies;
var _default = exports.default = getStoreCurrencyCode;